import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PageSlotModule } from '@spartacus/storefront';
import { SikoBreakpointObserverService } from '@siko/common';
import { B2bCommonModule } from '@siko/shared/b2b-common.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-blog-list-template',
    templateUrl: './blog-detail-outlet.component.html',
    styleUrls: ['./blog-detail-outlet.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [B2bCommonModule, PageSlotModule],
})
export class SikoBlogDetailOutletComponent {
    constructor(public breakpointObserver: SikoBreakpointObserverService) {}
}
